<div class="modal-header">
  <h2>{{ 'USER_PREFERENCE.MODALS.PAIR_DEVICE.TITLE' | translate }}</h2>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
    >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
@if (modalWizard === 'SERIAL') {
  <div
    class="modal-body p-3"
    [formGroup]="serialDeviceForm"
    >
    <label class="custom-label"
      >{{
      'USER_PREFERENCE.MODALS.PAIR_DEVICE.FORM.SERIAL_NUMBER.LABEL' | translate
      }}
      <input
        type="text"
        class="custom-input"
      [placeholder]="
        'USER_PREFERENCE.MODALS.PAIR_DEVICE.FORM.SERIAL_NUMBER.PLACEHOLDER'
          | translate
      "
        formControlName="serialNumber"
        />
    </label>
    <p class="pair-device-logout-message mt-3 mb-2 small">
      <strong>{{ 'USER_PREFERENCE.MODALS.PAIR_DEVICE.LOGOUT_WARNING_TITLE' | translate }}</strong><br>
      {{ 'USER_PREFERENCE.MODALS.PAIR_DEVICE.LOGOUT_WARNING_BODY' | translate }}
    </p>
    <label class="custom-label w-100">
      <input type="checkbox" formControlName="acceptLogoutAfterPair" />
      {{ 'USER_PREFERENCE.MODALS.PAIR_DEVICE.ACCEPT_LOGOUT' | translate }}
    </label>
  </div>
}
@if (modalWizard === 'SECURE_CODE') {
  <div
    class="modal-body p-3"
    [formGroup]="serialDeviceForm"
    >
    <label class="custom-label">
      {{
      'USER_PREFERENCE.MODALS.PAIR_DEVICE.FORM.SECURE_CODE.LABEL' | translate
      }}
    </label>
    <div class="d-flex justify-content-center mt-3">
      @for (sc of secureCodeControls; track sc; let i = $index) {
        <input
          type="text"
          class="custom-input pin-input me-2"
          [formControl]="sc"
          maxlength="1"
          appMoveNextByMaxLength
          />
      }
    </div>
  </div>
}
<div class="modal-footer">
  @if (modalWizard === 'SERIAL') {
    <button
      class="button-primary"
      (click)="onGenerateSecureCode()"
      [disabled]="!serialDeviceForm.valid"
      >
      {{ 'GLOBAL.CONTINUE' | translate }}
    </button>
  }
  @if (modalWizard === 'SECURE_CODE') {
    <button
      class="button-primary"
      (click)="onPair()"
      [disabled]="!secureCodeForm.valid"
      >
      {{ 'GLOBAL.ADD' | translate }}
    </button>
  }
</div>
